<div class="wrapper-modal">
  <form [formGroup]="createFaqItemForm" (ngSubmit)="submitFaqForm()" class="wrapper-content-modal">
    <div class="header-modal">
      <span class="title-modal">Dodajte novo pitanje i odgovor</span>
    </div>
    <div class="content-modal">
      <div class="wrapper-input">
        <span class="label-input">Pitanje</span>
        <div class="zc-input">
          <input type="text" [formControl]="createFaqItemForm.controls.question | formControl" [placeholder]="'Upišite pitanje'">
        </div>
        <span class="error-message">{{createFaqItemForm.controls.question | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Odgovor</span>
        <div class="zc-input">
          <input type="text" [formControl]="createFaqItemForm.controls.answer | formControl" [placeholder]="'Upišite odgovor'">
        </div>
        <span class="error-message">{{createFaqItemForm.controls.answer | formControlErrorMessages: null: formTriedToSubmit}}</span>
      </div>
      <gr-dropdown-reactive-form
        [items]="typeOfUsers"
        [propIdentifier]="'nameForDB'"
        [dropdownLabel]="'Tip korisnika'"
        [placeholder]="'Izaberite tip korisnika'"
        [formControl]="createFaqItemForm.controls.type | formControl"
        [formTriedToSubmit]="formTriedToSubmit"
      ></gr-dropdown-reactive-form>
    </div>
    <div class="footer-modal">
      <button type="button" (click)="closeModal.emit()" class="zc-btn zc-btn--gray"><span>Izađi</span></button>
      <button type="submit" class="zc-btn zc-btn--primary"><span>{{faqForEdit ? 'Izmeni' : 'Dodaj'}}</span></button>
    </div>
  </form>
</div>
